"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
var _input = _interopRequireDefault(require("../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h5", null, "Entry Fees"));
class EntryFees extends _react.Component {
  render() {
    const application = this.props.application;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, application.applicationTiers.map((tier, i) => /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "card-block",
      style: i === 0 ? null : {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 3
    }, /*#__PURE__*/_react.default.createElement("strong", null, tier.tierDescription)), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 9
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        xs: 8,
        sm: 5,
        md: 6,
        lg: 5
      }, {
        xs: 4,
        sm: 7,
        md: 6,
        lg: 7
      }]
    }, !tier.defaultTier.entryFee ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, /*#__PURE__*/_react.default.createElement(_label.default, null, "Standard Fees (", (0, _gbp.default)(tier.defaultTier.entryFee), ")"), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "useStandardFees",
      checked: tier.useStandardFees,
      onChange: (value, name) => this.props.setValue(tier.id, value, name)
    }))), application.calendarID === 2021 && tier.enhancedFeeTbd ? 'Delayed Fee Decision because of Covid' : tier.useStandardFees && tier.defaultTier.entryFee ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, /*#__PURE__*/_react.default.createElement(_label.default, null, tier.defaultTier.entryFee ? 'Enhanced' : 'Entry', " Fee (pence)"), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "enhancedFee",
      value: tier.enhancedFee,
      onChange: (value, name) => this.props.setValue(tier.id, value, name)
    }))))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EntryFees, "partialQueries", {
  Application: {
    id: true,
    calendarID: true,
    applicationTiers: {
      id: true,
      useStandardFees: true,
      enhancedFee: true,
      enhancedFeeTbd: true,
      tierDescription: true,
      defaultTier: {
        entryFee: true,
        isFreeToEnter: true
      }
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(EntryFees, undefined, (client, props) => ({
  setValue(id, value, field) {
    return client.update('ApplicationTier.set', {
      id,
      value,
      field
    });
  }
}));